export default function StatCard({ icon: Icon, label, value, hint, tone = "emerald", testId }) {
  const tones = {
    emerald: "bg-emerald-900 text-white",
    gold: "bg-amber-500 text-emerald-950",
    white: "bg-white text-emerald-950 border border-emerald-900/10",
    danger: "bg-red-600 text-white",
  };
  return (
    <div data-testid={testId} className={`rounded-2xl p-6 ${tones[tone]} transition-all hover:-translate-y-0.5 hover:shadow-lg`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold opacity-80">{label}</span>
        {Icon && <Icon className="h-5 w-5 opacity-80" />}
      </div>
      <div className="mt-3 font-heading text-3xl font-black tabular-nums">{value}</div>
      {hint && <div className="text-xs opacity-70 mt-1">{hint}</div>}
    </div>
  );
}
